
var map = L.map('map').setView([20.66471096858621, -103.34398189523752], 12); // Coordenadas iniciales
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '© OpenStreetMap'
}).addTo(map);
var markers = L.markerClusterGroup();
function obtenerMarcadores(restaurantes){
    markers.clearLayers();
    restaurantes.forEach(markerData => {
        const [latitud, longitud] = markerData.coordenadas.split(", ").map(Number);
        var categoriasArray = markerData.categoria.split(",");
        var greenIcon = L.icon({
            
            iconUrl: 'build/img/pines/'+ categoriasArray[0] +'.webp',
        
            iconSize: [50, 50], // Dimensiones del ícono cuadrado (ancho, alto) 
            iconAnchor: [25, 25], // Punto del ícono que corresponde a la posición del marcador (centrado)
            popupAnchor: [0, -25]
        });
        var marker = L.marker([latitud, longitud],{
            icon: greenIcon,
            linkinsta: markerData.link,
            id: markerData.id
        })
        marker.bindPopup(`<div class="contenedor-popup"><div class="contenido"><h2>${markerData.nombre}</h2><p class="categoria">${markerData.categoria}</p><p class="direccion">${markerData.direccion}</p><p class="precio"> Ticket promedio por persona: $${markerData.precio}</p> <a href="${markerData.link}" target="_blank"><div class="instaLink"><p>Ver en instagram</p></div></a></div></div>`)
        markers.addLayer(marker);
    });
    map.addLayer(markers);
}


$(document).ready(function() {
    $('#geocoder').autocomplete({
        source: function(request, response) {
            $.ajax({
                url: `https://nominatim.openstreetmap.org/search`,
                data: {
                    q: request.term,
                    format: 'json',
                    addressdetails: 1,
                    limit: 5
                },
                success: function(data) {
                    response(data.map(item => ({
                        label: item.display_name,
                        value: item.display_name,
                        lat: item.lat,
                        lon: item.lon
                    })));
                }
            });
        },
        select: function(event, ui) {
            map.setView([ui.item.lat, ui.item.lon], 13);
        }
    });
});

function obtenerTexto(valor){
    let coordenadas = valor.getAttribute("data-coord");
    const [latitud, longitud] = coordenadas.split(", ").map(Number);
    coordenadas = [latitud, longitud]
    map.setView(coordenadas, 19);
    var anchoPantalla = window.innerWidth;
    if( anchoPantalla < 992){
        document.getElementById("map").style.display = "block"
        document.getElementsByClassName("busqueda-section")[0].style.display = "none"
        setTimeout(function() { 
            map.invalidateSize();
        }, 100);
        document.getElementById("mostrarMapa").checked = true
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const data = JSON.parse(localStorage.getItem('formData')) || { checkboxes: [], min: 0, max: 0 };

    data.checkboxes.forEach((id) => {
        var filtroActivar  = document.getElementById(id).checked = true; 
    });
    const min = document.getElementById("precioMin").value = data.min
    const max = document.getElementById("precioMax").value = data.max

    const numberValue = data.number;
    localStorage.removeItem('formData')
});

let debounceTimer;
document.getElementById("campo").addEventListener("keyup",getData)


let filtprecios = document.querySelectorAll('.filt-pre');
filtprecios.forEach(filtro => {
    filtro.addEventListener('keyup', getData)
    filtro.addEventListener('change', getData)
})

let checkboxes = document.querySelectorAll('input[name="categorias[]"]');
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change",getData)
    });
function getData(){
    document.getElementsByClassName("busqueda-carga")[0].style.display = "flex"
    document.getElementsByClassName("busqueda-carga")[1].style.display = "flex"
    document.getElementsByClassName("carga_filtros-movil")[0].style.display = "inline-block"
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
        let input = document.getElementById("campo").value
        var anchoPantalla = window.innerWidth;
        if( anchoPantalla < 992){
            var min = document.getElementById("precioMin2").value
            var max = document.getElementById("precioMax2").value
        }else{
            var min = document.getElementById("precioMin").value
            var max = document.getElementById("precioMax").value
        }
        let contenedor  = document.getElementById("busquedaResultado")
        if(input.length > 0 || checkboxes.length > 0){
            let url = "load.php"
            let formData = new FormData()
            let checkboxes = document.querySelectorAll('input[name="categorias[]"]:checked');
            checkboxes.forEach(checkbox => {
                formData.append('categorias[]', checkbox.value);
            });
            formData.append('precioMin', min)
            formData.append('precioMax', max)
            formData.append('campo', input)
            fetch(url,{
                method: "POST",  
                body: formData,
                mode:"cors" 
            }).then(response => response.json())
            .then(data =>{
                document.getElementsByClassName("busqueda-carga")[0].style.display = "none"
                document.getElementsByClassName("busqueda-carga")[1].style.display = "none"
                document.getElementsByClassName("carga_filtros-movil")[0].style.display = "none"
                contenedor.innerHTML = data.html
                obtenerMarcadores(data.restaurantes)
            }).catch(err => console.log(err))
        }else{
            contenedor.style.display = "none"
        }
    }, 2000);
}
getData()


//ocultar los filtros
const contenedorCategoria = document.getElementsByClassName("filtros_categoria-info")
const filtroCategoria = document.getElementsByClassName("filtros_categoria-opciones")
const flechaC = document.getElementsByClassName("categoria-flecha")

for(let i=0; i<2; i++){
    contenedorCategoria[i].addEventListener("click", function(){
        filtroCategoria[i].classList.toggle("activo")
        flechaC[i].classList.toggle("giro")
    })
}



const contenedorPrecio = document.getElementsByClassName("filtros_precio-info")
const filtroPrecio = document.getElementsByClassName("filtros_precio-opciones")
const flechaP = document.getElementsByClassName("precio-flecha")

for(let i=0; i<2; i++){
    contenedorPrecio[i].addEventListener("click", function(){
        filtroPrecio[i].classList.toggle("activo")
        flechaP[i].classList.toggle("giro")
    })
}

//Filtros en modo movil
document.getElementById("filtrosAvanzados").addEventListener("click", function(){
    document.getElementsByClassName("filtros-movil")[0].classList.toggle("active")
})

document.getElementById("mostrarMapa").addEventListener("change", function(){
    if(document.getElementById("mostrarMapa").checked){
        document.getElementById("map").style.display = "block"
        document.getElementsByClassName("busqueda-section")[0].style.display = "none"
        setTimeout(function() { 
            map.invalidateSize();
        }, 100);
    }else{
        document.getElementById("map").style.display = "none"
        document.getElementsByClassName("busqueda-section")[0].style.display = "flex"
    }
})

document.getElementsByClassName("filtros-salida")[0].addEventListener("click", function(){
    document.getElementsByClassName("filtros-movil")[0].classList.remove("active")
})
document.getElementsByClassName("filtrosCerrar-x")[0].addEventListener("click", function(){
    document.getElementsByClassName("filtros-movil")[0].classList.remove("active")
})


document.getElementsByClassName("ocultar-buscador")[0].addEventListener("click", function(){
    document.getElementById("busquedaResultado").classList.toggle("ocultar")
    dov = document.getElementsByClassName("ocultar-buscador-img")[0].classList.toggle("girar")
    setTimeout(function() { 
        map.invalidateSize();
    }, 1500);
})